import { Block } from "@/backend/models/block";
import { useBlockStore } from "@/frontend/store/BlockStore";
import { I18n } from "@/i18n/I18n";


export function BlockSearch({ setBlockList }: { setBlockList: (blockList: Block[]) => void }) {
  const blocks = useBlockStore((state) => state.blocks);

  const handleSearch = (searchString: string) => {
    let newBlockList = blocks;
    if (searchString !== '') {
      newBlockList = newBlockList.filter((block) => {
        return block.title.toLowerCase().includes(searchString.toLowerCase());
      });
    }
    setBlockList(newBlockList);
  };

  return (
    <input
      type="text"
      className="form-control mt-2 mb-2"
      aria-label={I18n.get('search')}
      placeholder={I18n.get('search')}
      onChange={(e) => (handleSearch(e.target.value))}
    />
  );
}
